import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Container } from '../Container';

export const Appointments = () => {
    const [appointments, setAppointments] = useState(null);

    const fetchData = async () => {
        try {
            const response = await axios.get('https://q4fb7uk6th.execute-api.us-west-2.amazonaws.com/develop/get-classes');
            setAppointments(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const educationDatas = appointments?.data.filter((item) => item.category === 'Education');
    const professionalServicesDatas = appointments?.data.filter((item) => item.category === 'Professional Services');

    const seriesOfImages = [
        'https://images.ctfassets.net/vhts96p7twn6/3EP65KXRkGdup0XbynwCYO/74d8067ac721ed08055a35b0ad53c0d2/the-hawaii-grown-coffee-series-hale-inu-kope.jpg',
        'https://images.ctfassets.net/vhts96p7twn6/sLVe5jjijbA3jnxX1FPOe/8f76f88acbf8055b0badef2aaf4b32aa/coffee-sensory-and-tasting.jpg',
        'https://images.ctfassets.net/vhts96p7twn6/1QzX291jPoAHkUfyXtMlxp/4579e17d47f9face7f4f8009720c59f6/variables-in-coffee-extraction.jpg',
        'https://images.ctfassets.net/vhts96p7twn6/5j3slUlwBYPmlZ8JTC6OR3/feac1415bb9985ec878d71ad6dcfff77/coffee-cupping.jpg'
    ]

    return (
        <div className='block' style={{ backgroundColor: 'rgb(229, 62, 62)' }}>
            {(educationDatas?.length === 0 || professionalServicesDatas?.length === 0) && (
                <div className='py-80 px-15 text-center'>
                    <h4 className='mb-5 text-light weight-black'>There are currently no available appointments at this time.</h4>
                    <div className='grid col-3 col-1-md'>
                        <div></div>
                        <p className='text-light mb-0'>We're constantly updating our availability, so please check back again soon. We truly appreciate your interest and look forward to helping you at the earliest opportunity. Thank you for your patience and understanding!</p>
                        <div></div>
                    </div>
                </div>
            )}
            {/* Education Section */}
            {professionalServicesDatas?.length > 0 && (
                <div className='block pb-30'>
                    <Container>
                        <h2 className='pt-30 mt-0 text-white'>Education</h2>
                        <div className='grid col-3 col-1-sm col-2-md gap-30 justify-center'>
                            {(() => {
                                const displayedIDs = new Set();
                                return educationDatas?.filter(item => {
                                    if (displayedIDs.has(item.appointmentTypeID)) {
                                        return false;
                                    }
                                    displayedIDs.add(item.appointmentTypeID);
                                    return true;
                                }).map((item, index) => {
                                    const classNameSlug = item.name.toLowerCase().replace(/\s+/g, '-');
                                    const classCategorySlug = item.category.toLowerCase().replace(/\s+/g, '-');

                                    const classNameSlugFilename = item.name
                                        .toLowerCase()
                                        .replace(/\s+/g, '-') // Replace spaces with dashes
                                        .replace(/[:'ʻ‘’]/g, '') // Remove colons, apostrophes, and various apostrophe-like characters
                                        .replace(/[^\w-]/g, '');

                                    const matchedImage = seriesOfImages.find(imgUrl =>
                                        imgUrl.includes(`/${classNameSlugFilename}.jpg`)
                                    ) || 'https://images.ctfassets.net/vhts96p7twn6/35rLI6vsEssWUQXqCXZ6z6/098cda4667a35ac832e8f5c148a0527e/ASCImageHolder_1.jpg'; // Default image
                                
                                    return (
                                        <div key={index} className='block'>
                                            <div className='grid col-2 gap-15'>
                                                <div className='relative w-full h-301'>
                                                    <img src={matchedImage} alt={item.name} className='fullscreen-image'/>
                                                </div>
                                                <div className='block'>
                                                    <h6 className='mb-0 text-white'><a href={`/${classCategorySlug}/${classNameSlug}`} className='button-hyperlink text-white'>{item.name}</a></h6>
                                                    <p className='weight-black text-white'>{item.calendar}</p>
                                                    <p className='family-font-secondary text-sm weight-black text-white text-ellipsis line-5'>{item.description}</p>
                                                    <a href={`/${classCategorySlug}/${classNameSlug}`} className='button-hyperlink text-sm text-white link-underline'>View Course</a>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                });
                            })()}
                        </div>
                    </Container>
                </div>
            )}

            {/* Professional Services Section */}
            {educationDatas?.length > 0 && (
                <div className='block pb-30 bg-transparent-white-3'>
                    <Container>
                        <h2 className='pt-30 mt-0 text-white'>Professional Services</h2>
                        <div className='grid col-3 col-1-sm col-2-md gap-30 justify-center'>
                            {(() => {
                                const displayedIDs = new Set();
                                return professionalServicesDatas?.filter(item => {
                                    if (displayedIDs.has(item.appointmentTypeID)) {
                                        return false; // Skip duplicate
                                    }
                                    displayedIDs.add(item.appointmentTypeID);
                                    return true;
                                }).map((item, index) => {
                                    const classNameSlug = item.name.toLowerCase().replace(/\s+/g, '-');
                                    const classCategorySlug = item.category.toLowerCase().replace(/\s+/g, '-');
                                    const classNameSlugFilename = item.name
                                        .toLowerCase()
                                        .replace(/\s+/g, '-') // Replace spaces with dashes
                                        .replace(/[:'ʻ‘’]/g, '') // Remove colons, apostrophes, and various apostrophe-like characters
                                        .replace(/[^\w-]/g, '');

                                    const matchedImage = seriesOfImages.find(imgUrl =>
                                        imgUrl.includes(`/${classNameSlugFilename}.jpg`)
                                    ) || 'https://images.ctfassets.net/vhts96p7twn6/35rLI6vsEssWUQXqCXZ6z6/098cda4667a35ac832e8f5c148a0527e/ASCImageHolder_1.jpg'; // Default image
                                    return (
                                        <div key={index} className='block'>
                                            <div className='grid col-2 gap-15'>
                                                <div className='relative w-full h-301'>
                                                    <img src={matchedImage} alt={item.name} className='fullscreen-image'/>
                                                </div>
                                                <div className='block'>
                                                    <h6 className='mb-0 text-white'><a href={`/${classCategorySlug}/${classNameSlug}`} className='button-hyperlink'>{item.name}</a></h6>
                                                    {/* <p className='mb-0 weight-black'>{item.localeTime}</p> */}
                                                    <p className='weight-black text-white'>{item.calendar}</p>
                                                    <p className='family-font-secondary text-sm weight-black text-ellipsis line-5 text-white'>{item.description}</p>
                                                    <a href={`/${classCategorySlug}/${classNameSlug}`} className='button-hyperlink text-sm text-white link-underline'>View Course</a>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                });
                            })()}
                        </div>
                    </Container>
                </div>
            )}
        </div>
    );
};
